import { Company, Customer, Entity, Lead } from "../api";

export const getLeadTitle = (lead: Lead) => {
  return (
    lead.title ||
    `${lead.primaryVehicleModel?.name || ""} ${
      lead.primaryVehicleVariant?.name || ""
    }`.trim() ||
    `${lead.leadType?.name}` ||
    `${lead.customer?.fullName}` ||
    getCustomerTitle(lead.customer) ||
    lead._id
  );
};

export const getCustomerTitle = (customer?: Customer) => {
  if (!customer) {
    return undefined;
  }
  return (
    customer.fullName ||
    customer.name ||
    `${customer.firstName || ""} ${customer.lastName || ""}`.trim() ||
    customer.phone ||
    customer.primaryPhone ||
    customer.primaryEmail
  );
};

export const getInvalidCustomerFieldsEnquiry = (
  customer: Customer,
  entity: Entity
) => {
  const invalidFields: any[] = [];
  entity?.fields?.forEach((p) => {
    if (p.group === "workDetails") {
      if (!(customer?.workDetails?.[0] as any)?.[p.value]) {
        invalidFields.push(p.displayName);
      }
    } else {
      if (p.value === "primaryEmail") {
        if (!customer.primaryEmail) {
          invalidFields.push(p.displayName);
        }
      } else if (p.value === "identifiers.civilId") {
        if (!customer?.identifiers?.civilId) {
          if (!customer?.isCompanyCustomer) {
            invalidFields.push(p.displayName);
          } else {
            invalidFields.push("CRN Number");
          }
        }
      } else if (p.value === "dob") {
        if (!customer?.dob) {
          if (!customer?.isCompanyCustomer) {
            invalidFields.push(p.displayName);
          } else {
            invalidFields.push("Registration Date");
          }
        }
      } else if (p.value === "identifiers.nationality") {
        if (!customer?.identifiers?.nationality) {
          invalidFields.push(p.displayName);
        }
      } else if (p.value === "addresses") {
        if (!customer?.addresses?.length) {
          invalidFields.push(p);
        }
      } else if (!(customer as any)[p.value]) {
        invalidFields.push(p.displayName);
      }
    }
  });
  return invalidFields;
};

export const getInvalidCustomerFieldsTestDrive = (
  customer: Customer,
  isCustomerAvailableInShowroomRequiredForTestDrive: boolean
) => {
  if (!isCustomerAvailableInShowroomRequiredForTestDrive) {
    return [];
  }
  const invalidFields = [];
  if (!customer?.gender) {
    invalidFields.push("Gender");
  }
  const governorate = customer.civilIdDetails
    ? customer.civilIdDetails?.address?.governorate
    : customer?.addresses?.[0]?.governorate;
  if (!governorate) {
    invalidFields.push("Governorate");
  }

  const area = customer.civilIdDetails
    ? customer.civilIdDetails?.address?.area
    : customer?.addresses?.[0]?.district;

  if (!area) {
    invalidFields.push("Area");
  }

  if (!customer?.dob) {
    invalidFields.push("DOB");
  }

  if (!customer?.identifiers?.nationality) {
    invalidFields.push("Nationality");
  }

  return invalidFields;
};

export const getInvalidFields = (
  customer: Customer,
  entity: Entity[],
  leadDetails?: Lead
) => {
  const invalidFields: any[] = [];
  entity?.forEach((en) => {
    en?.fields?.forEach((p) => {
      if (p?.type === "lead") {
        if (!(leadDetails as any)[p.value]) {
          invalidFields.push(p.displayName);
        }
      } else {
        if (p.group === "workDetails") {
          if (!(customer?.workDetails?.[0] as any)?.[p.value]) {
            invalidFields.push(p.displayName);
          }
        } else {
          if (p.value === "primaryEmail") {
            if (!customer.primaryEmail) {
              invalidFields.push(p.displayName);
            }
          } else if (p.value === "identifiers.civilId") {
            if (!customer?.identifiers?.civilId) {
              invalidFields.push(p.displayName);
            }
          } else if (p.value === "identifiers.nationality") {
            if (!customer?.identifiers?.nationality) {
              invalidFields.push(p.displayName);
            }
          } else if (p.value === "addresses") {
            if (!customer?.addresses?.length) {
              invalidFields.push(p);
            }
          } else if (!(customer as any)[p.value]) {
            invalidFields.push(p.displayName);
          }
        }
      }
    });
  });
  return invalidFields;
};

export const uppendCode = (phone: string) => {
  if (phone && (phone.startsWith("91") || phone.startsWith("+91"))) {
    return phone;
  }
  return `91${phone}`;
};

export const getCompanyTitle = (company?: Company) => {
  if (!company) {
    return undefined;
  }
  return (
    company.name ||
    company.phone ||
    company.primaryPhone ||
    company.primaryEmail
  );
};
